module.exports = __webpack_public_path__ + "50a55494.png";